import { TransitTransferIcon } from './TransitTransferIcon';

/**
 * author: Google
 * id CE6451FA-EF46-40B4-B87B-BCF93DDE6E54
 * name transit-transfer
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/transit-transfer.svg
 * tags
 * - Transportation + Other 
 * - Navigation 
 */
export const TransferWithinAStationIcon = TransitTransferIcon;
export default TransferWithinAStationIcon